function formatCurrency (value, isInteger = false) {
    if (isNaN(value)) {
        return value;
    }
    if ((typeof value !== "undefined") && (value !== '')) {
	    if (isInteger) {
		    return "$" + parseFloat(value);
	    }
        return "$" + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    return "";
}

export default formatCurrency;
